import React, { Component } from "react";
import ReactGA from "react-ga4";
import ReactPixel from "react-facebook-pixel";

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = (page) => {
    if (localStorage.getItem("enableGoogleAnalytics") === "true") {
      ReactGA.initialize(localStorage.getItem("googleAnalyticsId"));
      ReactGA.send({ hitType: "pageview", page, ...options });
    }
  };

  const trackPagePixel = (page) => {
    if (localStorage.getItem("enableMetaPixel") === "true") {
      const pixelId = localStorage.getItem("metaPixelId");
      if (pixelId) {
        ReactPixel.init(pixelId);
        ReactPixel.pageView();
      }
    }
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
      trackPagePixel(page);
    }

    componentDidUpdate(prevProps) {
      const currentPage = prevProps.location.pathname;
      const nextPage = this.props.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
        trackPagePixel(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default withTracker;